(function () {
    'use strict';

    angular.module('asys')
        .controller('ReiterFahrzeugController', ReiterFahrzeugController);

    ReiterFahrzeugController.$inject = [
        '$scope',
        '$log',
        '$filter',
        '$timeout',
        'lodash',
        'moment',
        'AppConfig',
        'AngebotKfzService',
        'BasisAngebotService',
        'MiscUtilsService',
        'NavigationService',
        'ValidationMessageService',
        'HtmlUtilsService'
    ];
    function ReiterFahrzeugController($scope, $log, $filter, $timeout, _, moment, AppConfig, AngebotKfzService, BasisAngebotService, MiscUtilsService, NavigationService, ValidationMessageService, HtmlUtilsService) {
        var vm = this,
            angebotVm = $scope.angebotVm,
            wkzWert = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.wkz.wert'),
            wagniskennziffern = AppConfig.ANGEBOT.kfz.wkz,
            erlaubteTarifmerkmale = AngebotKfzService.getErlaubteTarifmerkmale(angebotVm.angebotModel.angebot),
            angebotAenderbar = BasisAngebotService.isAngebotAenderbar(angebotVm.angebotModel.angebot, 'ANGEBOT'),
            validationMessages = {},
            hsnTsnPending,
            hsnTsnGueltig;

        $log.debug('ReiterFahrzeugController', vm);

        vm.onSaisonfahrzeugChanged = onSaisonfahrzeugChanged;
        vm.onFahrzeugErstzulassungChanged = onFahrzeugErstzulassungChanged;
        vm.onFahrzeugErstzulassungIdentischChanged = onFahrzeugErstzulassungIdentischChanged;
        vm.onFahrzeughaltereigenschaftVnAnderePersonChanged = onFahrzeughaltereigenschaftVnAnderePersonChanged;
        vm.onFahrzeugFahrzeughaltereigenschaftChanged = onFahrzeugFahrzeughaltereigenschaftChanged;
        vm.ermittleFahrzeugdatenUeberHsnTsn = ermittleFahrzeugdatenUeberHsnTsn;
        vm.checkSaisonzeitraum = checkSaisonzeitraum;
        vm.checkMotorleistung = checkMotorleistung;
        vm.checkNutzlast = checkNutzlast;
        vm.checkZulassungsdatum = checkZulassungsdatum;
        vm.checkFahrzeugdatenHsnTsn = checkFahrzeugdatenHsnTsn;
        vm.isWkz = isWkz;
        vm.isHsnTsnErlaubt = isHsnTsnErlaubt;
        vm.isFahrzeugsucheTypErlaubt = isFahrzeugsucheTypErlaubt;
        vm.isPostleitzahlFahrzeughalterErlaubt = isPostleitzahlFahrzeughalterErlaubt;
        vm.isFahrzeughalterErlaubt = isFahrzeughalterErlaubt;
        vm.isFahrzeugZulassungAufFahrzeughalterErlaubt = isFahrzeugZulassungAufFahrzeughalterErlaubt;
        vm.isSaisonkennzeichenErlaubt = isSaisonkennzeichenErlaubt;
        vm.isJaehrlicheFahrleistungErlaubt = isJaehrlicheFahrleistungErlaubt;
        vm.isMotorradHerstellerErlaubt = isMotorradHerstellerErlaubt;
        vm.isMotorleistungErlaubt = isMotorleistungErlaubt;
        vm.isNutzlastErlaubt = isNutzlastErlaubt;
        vm.isSitzplaetzeErlaubt = isSitzplaetzeErlaubt;
        vm.isNeuwertErlaubt = isNeuwertErlaubt;
        vm.isAufbauartErlaubt = isAufbauartErlaubt;
        vm.isKaufpreisErlaubt = isKaufpreisErlaubt;
        vm.isAntiblockiersystemErlaubt = isAntiblockiersystemErlaubt;
        vm.isGlasfaserkunststoffdachErlaubt = isGlasfaserkunststoffdachErlaubt;
        vm.isQuadErlaubt = isQuadErlaubt;
        vm.getLinkBezeichnungFahrzeugsuche = getLinkBezeichnungFahrzeugsuche;
        vm.toggleFahrzeugsuche = toggleFahrzeugsuche;
        vm.onCloseFahrzeugsucheKomfort = onCloseFahrzeugsucheKomfort;
        vm.onChangeFahrzeugsuche = onChangeFahrzeugsuche;
        vm.onSelectFahrzeugsuche = onSelectFahrzeugsuche;
        vm.isDirectNavigationToStepErgebnisErlaubt = isDirectNavigationToStepErgebnisErlaubt;
        vm.isFahrzeughalterPlzAbweichend = isFahrzeughalterPlzAbweichend;
        vm.isNutzungsartErlaubt = isNutzungsartErlaubt;
        vm.isGewerblicheBefoerderungErlaubt = isGewerblicheBefoerderungErlaubt;
        vm.isFinanzierungErlaubt = isFinanzierungErlaubt;

        vm.isHerstellerschluesselDisabled = isHerstellerschluesselDisabled;
        vm.isTypschluesselDisabled = isTypschluesselDisabled;
        vm.isFahrzeughaltereigenschaftDisabled = isFahrzeughaltereigenschaftDisabled;
        vm.isMotorleistungDisabled = isMotorleistungDisabled;
        vm.isSaisonkennzeichenDisabled = isSaisonkennzeichenDisabled;
        vm.isSaisonzeitraumVonDisabled = isSaisonzeitraumVonDisabled;
        vm.isSaisonzeitraumBisDisabled = isSaisonzeitraumBisDisabled;
        vm.isFahrzeugZulassungAufFahrzeughalterDisabled = isFahrzeugZulassungAufFahrzeughalterDisabled;
        vm.isAufbauartDisabled = isAufbauartDisabled;
        vm.isFahrzeugErstzulassungDisabled = isFahrzeugErstzulassungDisabled;
        vm.saisonzeitraumBisOrder = saisonzeitraumBisOrder;
        vm.isGevo = isGevo;
        vm.getMotorleistungTyp = getMotorleistungTyp;
        vm.isHinweisFahrzeugErstzulassungSichtbar = isHinweisFahrzeugErstzulassungSichtbar;
        vm.onMotorleistungChanged = onMotorleistungChanged;

        vm.saisonzeitraumVon = function (saisonzeitraumVon) {
            if (arguments.length) {
                if (_.indexOf(angebotVm.CONSTANTS.monate, saisonzeitraumVon) > -1) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonzeitraumVon', _.indexOf(angebotVm.CONSTANTS.monate, saisonzeitraumVon) + 1);
                } else {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonzeitraumVon', null);
                }
                return saisonzeitraumVon;
            } else {
                if (_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonzeitraumVon')) {
                    return angebotVm.CONSTANTS.monate[_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonzeitraumVon') - 1];
                }

                return null;
            }
        };

        vm.saisonzeitraumBis = function (saisonzeitraumBis) {
            if (arguments.length) {
                if (_.indexOf(angebotVm.CONSTANTS.monate, saisonzeitraumBis) > -1) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonzeitraumBis', _.indexOf(angebotVm.CONSTANTS.monate, saisonzeitraumBis) + 1);
                } else {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonzeitraumBis', null);
                }
                return saisonzeitraumBis;
            } else {
                if (_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonzeitraumBis')) {
                    return angebotVm.CONSTANTS.monate[_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonzeitraumBis') - 1];
                }

                return null;
            }
        };

        vm.motorleistung = function (motorleistung) {
            var leistung = _.isNaN(parseInt(motorleistung, 10)) ? null : parseInt(motorleistung, 10);

            if (arguments.length) {
                if (leistung >= 0) {
                    if (_.get(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungTyp', 'kW') === 'kW') {
                        _.set(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungInKw', leistung);
                        _.set(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungInPs', Math.round(leistung * 1.359621617));
                    } else if (_.get(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungTyp') === 'PS') {
                        _.set(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungInPs', leistung);
                        _.set(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungInKw', Math.round(leistung * 0.73549875));
                    }
                } else {
                    _.set(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungInKw', leistung);
                    _.set(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungInPs', leistung);
                }

                return leistung;
            } else {
                if (_.get(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungTyp', 'kW') === 'kW') {
                    return _.get(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungInKw', null);
                } else if (_.get(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungTyp') === 'PS') {
                    return _.get(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungInPs', null);
                }

                return null;
            }
        };

        vm.fahrzeughaltereigenschaftVnAnderePerson = function (fahrzeughalterVn) {
            if (arguments.length) {
                if (fahrzeughalterVn) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft', _.get(BasisAngebotService.getConstant('fahrzeughaltereigenschaften', angebotVm.angebotModel.angebot), 'versicherungsnehmer'));
                } else if (fahrzeughalterVn === false) {
                    if (_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert') === _.get(BasisAngebotService.getConstant('fahrzeughaltereigenschaften', angebotVm.angebotModel.angebot), 'versicherungsnehmer.wert')) {
                        _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft', null);
                    }
                }

                _.set(angebotVm.angebotModel.formData, 'fahrzeughaltereigenschaftVnAnderePerson', fahrzeughalterVn);

                return fahrzeughalterVn;
            } else {
                if (_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert') && _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert') === _.get(BasisAngebotService.getConstant('fahrzeughaltereigenschaften', angebotVm.angebotModel.angebot), 'versicherungsnehmer.wert')) {
                    return true;
                } else if (MiscUtilsService.isNotEmpty(_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert'))) {
                    return false;
                } else {
                    return _.get(angebotVm.angebotModel.formData, 'fahrzeughaltereigenschaftVnAnderePerson');
                }
            }
        };

        activate();

        function activate() {
            hsnTsnPending = false;
            hsnTsnGueltig = !!_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.hsnTsnBezeichnung');
            vm.tarifauskunftsdatum = BasisAngebotService.getTarifauskunftsdatum(angebotVm.angebotModel.angebot) || moment().format(AppConfig.API.dateFormat);
            vm.previousStep = isGevo('KFZ_TARIFUMSTELLUNG') ? null : 'rechner.gevo';

            vm.showFahrzeugNeuwert = false;
            vm.zulassungDatumRegeln = getZulassungDatumRegeln();
            vm.berechnenBtnText = angebotAenderbar ? 'Beitrag berechnen' : 'Beitrag anzeigen';
            vm.filteredFahrzeughaltereigenschaft = getFilteredFahrzeughaltereigenschaft();
            vm.AngebotKfzService = AngebotKfzService;
            if (!BasisAngebotService.isPrivatPerson(angebotVm.angebotModel.angebot)) {
                vm.fahrzeughaltereigenschaftVnLabel = 'Firma selbst';
                vm.fahrzeughaltereigenschaftAnderePersonLabel = 'Abweichender Fahrzeughalter';
                vm.fahrzeughaltereigenschaftBanned = null;
            } else {
                vm.fahrzeughaltereigenschaftVnLabel = 'Ich selbst';
                vm.fahrzeughaltereigenschaftAnderePersonLabel = 'Andere Person';
                vm.fahrzeughaltereigenschaftBanned = '4';
            }

            if (wkzWert === wagniskennziffern.MOTORRAD) {
                vm.motorleistungValidatorName = 'motorleistungMotorrad';
            } else if (_.includes([
                wagniskennziffern.LEICHTKRAFTROLLER_50_BIS_125_CCM,
                wagniskennziffern.LEICHTKRAFTRAEDER_50_BIS_135_CCM
            ], wkzWert)) {
                vm.motorleistungValidatorName = 'motorleistungLeichtkraft';
            } else if (_.includes([
                wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_GRÜNEM_KENNZEICHEN,
                wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_SCHWARZEM_KENNZEICHEN
            ], wkzWert)) {
                vm.motorleistungValidatorName = 'motorleistungZugmaschinenQuad';
            } else if (wkzWert === wagniskennziffern.QUAD_VIERRAEDRIGES_MOTORRAD) {
                vm.motorleistungValidatorName = 'motorleistungQuad';
            }
            _.set(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungTyp', 'kW');
            _.set(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungInKw', _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.motorleistung'));
            _.set(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungInPs', Math.round(parseInt(_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.motorleistung'), 10) * 1.359621617));
            getMotorleistungTyp();

            _.set(angebotVm.angebotModel, 'formData.fahrzeugsuche.typ', 'hsntsn');
            MiscUtilsService.setDefaultValueIfEmpty(angebotVm.angebotModel, 'formData.fahrzeugsuche.suchTyp', 'komfort');
            vm.placeholders = {
                zulassungDatum: {
                    'min, max': [
                        $filter('date')(vm.zulassungDatumRegeln.min, 'dd.MM.yyyy'),
                        $filter('date')(vm.zulassungDatumRegeln.max, 'dd.MM.yyyy')
                    ]
                },
                gewerblicheBefoerderung: {
                    banned: [
                        angebotVm.isPrivatPerson ? AppConfig.APP.telefon : AppConfig.APP.telefonFirmenkunde,
                        angebotVm.isPrivatPerson ? '' : ' oder per E-Mail an kfz-firmen@wgv.de'
                    ]
                },
                fahrzeughaltereigenschaft: {
                    banned: [
                        angebotVm.isPrivatPerson ? AppConfig.APP.telefon : AppConfig.APP.telefonFirmenkunde,
                        angebotVm.isPrivatPerson ? '' : ' oder per E-Mail an kfz-firmen@wgv.de'
                    ]
                },
                nutzlast: {
                    nutzlastAnhaenger: [
                        angebotVm.isPrivatPerson ? AppConfig.APP.telefon : AppConfig.APP.telefonFirmenkunde,
                        angebotVm.isPrivatPerson ? '' : ' oder per E-Mail an kfz-firmen@wgv.de'
                    ]
                },
                angebotsgegenstandFahrzeugZulassungsdatum: {
                    zulassungsdatum: [
                        '' // Wert wird in checkZulassungsdatum gesetzt
                    ]
                }
            };
            vm.CONSTANTS = {
                nutzungsart: BasisAngebotService.getConstant('nutzungsart', angebotVm.angebotModel.angebot)
            };

            vm.typeaheadHerstellerOptions = {
                fuzzySearch: true,
                displayTemplate: '<%= data.bezeichnung %>',
                trackByProperty: 'wert',
                validation: {
                    showMessageOnValidate: true
                }
            };

            ValidationMessageService.get('fzgForm.angebotsgegenstandFahrzeugZulassungsdatum').then(function (messages) {
                validationMessages.angebotsgegenstandFahrzeugZulassungsdatum = messages;
            });

            if (!isHsnTsnErlaubt()) {
                angebotVm.fahrzeugNeuwertUeberSchwackeErmittelt = false;
            } else if (!isHerstellerschluesselDisabled() && !isTypschluesselDisabled()) {
                ermittleFahrzeugdatenUeberHsnTsn(false, false);
            }
            if (isPostleitzahlFahrzeughalterErlaubt() && MiscUtilsService.isNotEmpty(_.get(angebotVm.angebotModel.angebot, 'antragsteller.postleitzahl')) && MiscUtilsService.isEmpty(_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter.postleitzahl'))) {
                AngebotKfzService.getZulassungsbezirke(angebotVm.angebotModel, _.get(angebotVm.angebotModel.angebot, 'antragsteller.postleitzahl'), true).then(function (zulassungsbezirke) {
                }).catch(function () {
                });
            }

            isFahrzeughalterPlzAbweichend(['VN_ANTRAGSTELLER']);

            $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                var cancleStateChange = false;

                BasisAngebotService.mapFormToServiceData(angebotVm.angebotModel.formData, angebotVm.angebotModel.angebot, angebotVm.angebotModel.angebotInitial);

                if (NavigationService.isFollowing(toState.name)) {

                    if (isFahrzeughalterPlzAbweichend(['VN_ANTRAGSTELLER']).status) {
                        cancleStateChange = true;
                    }

                    if (cancleStateChange) {
                        event.preventDefault();

                        if (vm.fzgForm) {
                            if (vm.fzgForm.submitInProgress) {
                                vm.fzgForm.submitInProgress = false;
                            }

                            vm.fzgForm.stateChangeCanceled = true;
                        }

                        return;
                    } else {
                        if (vm.fzgForm) {
                            vm.fzgForm.stateChangeCanceled = false;
                        }
                    }
                }
            });

            $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                vm.stateChangeSuccess = false;

                $timeout(function () {
                    vm.stateChangeSuccess = true;
                }, 0);

            });
        }
        function onSaisonfahrzeugChanged(value) {
            var defaultJaehrlicheFahrleistungBeiSaison = _.get(AppConfig.ANGEBOT, 'kfz.defaults.jaehrlicheFahrleistungSaison');

            if (
                value &&
                MiscUtilsService.isNotEmpty(defaultJaehrlicheFahrleistungBeiSaison) &&
                !AngebotKfzService.isJaehrlicheFahrleistungErlaubt(angebotVm.angebotModel.angebot)
            ) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.jaehrlicheFahrleistung', defaultJaehrlicheFahrleistungBeiSaison);
            }

            if (!value) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonzeitraumVon', null);
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonzeitraumBis', null);
            }
        }

        function onFahrzeugErstzulassungChanged(value) {
            if (isFahrzeugZulassungAufFahrzeughalterErlaubt() && !isFahrzeugZulassungAufFahrzeughalterDisabled()) {
                if (_.get(angebotVm.angebotModel.formData, 'fahrzeugErstzulassungIdentisch')) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.zulassungAufFahrzeughalter', value);
                }

                if (!value || value !== _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.zulassungAufFahrzeughalter')) {
                    _.set(angebotVm.angebotModel.formData, 'fahrzeugErstzulassungIdentisch', false);

                    $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.fzgForm, 'fahrzeugErstzulassungIdentisch.$$element') ], {
                        state: 'default',
                        force: true
                    });
                }
            }

            if (moment().diff(moment(value, AppConfig.API.dateFormat), 'years', false) < 20) {
                if (_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.kaskoart') === 'KEINE') {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.kaskoart', 'VOLLKASKO');
                    _.set(angebotVm.angebotModel.angebot, 'bausteinVollkasko.aktiv', true);
                    _.set(angebotVm.angebotModel.angebot, 'bausteinTeilkasko.aktiv', false);
                }
            } else {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.kaskoart', 'KEINE');
                _.set(angebotVm.angebotModel.angebot, 'bausteinVollkasko.aktiv', false);
                _.set(angebotVm.angebotModel.angebot, 'bausteinTeilkasko.aktiv', false);
            }
        }

        function onFahrzeugErstzulassungIdentischChanged(value) {
            if (isFahrzeugZulassungAufFahrzeughalterErlaubt() && !isFahrzeugZulassungAufFahrzeughalterDisabled()) {
                if (value && _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.erstzulassung')) {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.zulassungAufFahrzeughalter', _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.erstzulassung'));

                    $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.fzgForm, 'angebotsgegenstandFahrzeugZulassungAufFahrzeughalter.$$element') ], {
                        state: 'unchangeable',
                        force: true
                    });
                } else {
                    _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.zulassungAufFahrzeughalter', null);
                }
            }
        }

        function onFahrzeughaltereigenschaftVnAnderePersonChanged(value) {
            _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter', null);
            _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', null);
            _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter', null);
            _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.zbn', null);

            _.set(angebotVm.angebotModel.formData, 'fahrzeughalter', null);
            _.set(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', null);

            BasisAngebotService.resetBeitraege(angebotVm.angebotModel.angebot);
        }
        function onFahrzeugFahrzeughaltereigenschaftChanged(value) {
            NavigationService.setFollowingDisabled(true);

            _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft', value);
            _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter', null);
            _.set(angebotVm.angebotModel.formData, 'fahrzeughalter', null);

            if (
                !BasisAngebotService.isPrivatPerson(angebotVm.angebotModel.angebot) &&
                _.get(value, 'wert') === '2' // Autohaus/Kaufpreisrabatt
            ) {
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter.mitgliedsart', BasisAngebotService.getConstant('mitgliedsarten').firmenkunde);
            }
        }
        function getFilteredFahrzeughaltereigenschaft() {
            return AngebotKfzService.getFilteredFahrzeughaltereigenschaft(angebotVm.angebotModel.angebot, angebotVm.sw.fahrzeughaltereigenschaft);
        }
        function getZulassungDatumRegeln() {
            if (!BasisAngebotService.isAngebotAenderbar(angebotVm.angebotModel.angebot, 'ANTRAG')) {
                return {
                    min: '',
                    max: ''
                };
            }

            return AngebotKfzService.getZulassungDatumRegeln(angebotVm.angebotModel.angebot);
        }
        function ermittleFahrzeugdatenUeberHsnTsn(isOnChange) {
            hsnTsnPending = true;
            isOnChange = isOnChange === false ? false : true;

            resetFahrzeugsucheModelIfNeeded();

            AngebotKfzService.getFahrzeugDatenHsnTsn(angebotVm.angebotModel).then(function (fahrzeugDatenHsnTsn) {
                var neuwertUeberSchwackeErmittelt = MiscUtilsService.isNotEmpty(fahrzeugDatenHsnTsn.fahrzeugneuwert),
                    neuwert = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.neuwert');

                _.set(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.fahrzeugDatenHsnTsn', fahrzeugDatenHsnTsn);

                angebotVm.fahrzeugNeuwertUeberSchwackeErmittelt = neuwertUeberSchwackeErmittelt;
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.hsnTsnBezeichnung', fahrzeugDatenHsnTsn.bezeichnung ? fahrzeugDatenHsnTsn.bezeichnung : null);
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.neuwert', neuwertUeberSchwackeErmittelt ? fahrzeugDatenHsnTsn.fahrzeugneuwert : (isOnChange ? null : neuwert));
            }).catch(function () {
                angebotVm.fahrzeugNeuwertUeberSchwackeErmittelt = false;
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.hsnTsnBezeichnung', null);
                _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.neuwert', null);
                _.set(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.fahrzeugDatenHsnTsn', null);
            }).finally(function () {
                hsnTsnPending = false;
                hsnTsnGueltig = !!_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.hsnTsnBezeichnung');

                if (!_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.neuwert')) {
                    vm.showFahrzeugNeuwert = true;

                    $timeout(function () {
                        vm.showFahrzeugNeuwert = false;
                    }, 1000);
                }
            });
        }
        function checkSaisonzeitraum() {
            if (!_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonfahrzeug')) {
                return true;
            }

            var saisonVon = parseInt(_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonzeitraumVon'), 10),
                saisonBis = parseInt(_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonzeitraumBis'), 10),
                anzahlMonate = (saisonBis - saisonVon + 1) > 0 ? saisonBis - saisonVon + 1 : saisonBis - saisonVon + 13;

            if (MiscUtilsService.isAtLeastOneEmpty(saisonVon, saisonBis)) {
                return true;
            }

            if (anzahlMonate < 2 || anzahlMonate > 11) {
                return false;
            }

            return true;
        }
        function checkMotorleistung(value) {
            var motorleistungTyp = _.get(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungTyp'),
                motorleistung = Math.round(parseInt(value, 10) * (motorleistungTyp === 'PS' ? 0.73549875 : 1));

            if (!isMotorleistungErlaubt || MiscUtilsService.isEmpty(motorleistung)) {
                return true;
            }
            if (_.includes([
                wagniskennziffern.LEICHTKRAFTROLLER_50_BIS_125_CCM,
                wagniskennziffern.LEICHTKRAFTRAEDER_50_BIS_135_CCM
            ], wkzWert)) {
                return motorleistung <= 11;
            }
            if (_.includes([
                wagniskennziffern.MOTORRAD
            ], wkzWert)) {
                return motorleistung >= 5;
            }
            if (_.includes([
                wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_GRÜNEM_KENNZEICHEN,
                wagniskennziffern.LANDWIRTSCHAFTLICHE_ZUGMASCHINEN_MIT_SCHWARZEM_KENNZEICHEN
            ], wkzWert) && _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.quad')) {
                return motorleistung >= 16;
            }
            if (_.includes([
                wagniskennziffern.QUAD_VIERRAEDRIGES_MOTORRAD
            ], wkzWert)) {
                return motorleistung <= 15;
            }

            return true;
        }
        function checkNutzlast(value) {
            if (!isNutzlastErlaubt || MiscUtilsService.isEmpty(value)) {
                return true;
            }
            if (_.includes([
                wagniskennziffern.ANHAENGER_WERKNAH_UND_PRIVATVERKEHR
            ], wkzWert)) {
                return value < 3000;
            }

            return true;
        }
        function checkZulassungsdatum() {
            var fahrzeugZulassungAufFahrzeughalterErlaubt = isFahrzeugZulassungAufFahrzeughalterErlaubt(),
                erstzulassung = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.erstzulassung'),
                zulassungAufFahrzeughalter = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.zulassungAufFahrzeughalter'),
                momentDuration999Months,
                validationText,
                valid = true;

            valid = (function () {
                if (!fahrzeugZulassungAufFahrzeughalterErlaubt) {
                    return true;
                }
                if (!fahrzeugZulassungAufFahrzeughalterErlaubt) {
                    return true;
                }

                momentDuration999Months = moment.duration(999, 'months');
                if (MiscUtilsService.isAtLeastOneEmpty(erstzulassung, zulassungAufFahrzeughalter)) {
                    return true;
                }
                if (!MiscUtilsService.isGreaterThan(zulassungAufFahrzeughalter, erstzulassung, {
                    equalAllowed: true
                })) {
                    validationText = _.get(validationMessages.angebotsgegenstandFahrzeugZulassungsdatum, 'zulassungAufHalterNachErstzulassung.message');
                    return false;
                }

                if (!moment().subtract(momentDuration999Months).isBefore(erstzulassung, AppConfig.API.dateFormat)) {
                    validationText = _.get(validationMessages.angebotsgegenstandFahrzeugZulassungsdatum, 'fahrzeugalterZuAlt.message');
                    return false;
                }

                return true;
            })();

            if (!valid && validationText) {
                _.set(vm.placeholders, 'angebotsgegenstandFahrzeugZulassungsdatum.zulassungsdatum', validationText);
            }

            return valid;
        }
        function checkFahrzeugdatenHsnTsn() {
            if (!isHsnTsnErlaubt()) {
                return true;
            }

            var herstellerschluessel = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.herstellerschluessel'),
                typschluessel = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.typschluessel');

            if (MiscUtilsService.isAtLeastOneEmpty(herstellerschluessel, typschluessel) || hsnTsnPending) {
                return true;
            }

            return hsnTsnGueltig;
        }
        function isWkz(wkz) {
            return wkzWert === wkz;
        }
        function isHsnTsnErlaubt() {
            return erlaubteTarifmerkmale.fahrzeugtyp;
        }
        function isFahrzeugsucheTypErlaubt() {
            return (
                !angebotVm.isErsatzgeschaeft() &&
                isHsnTsnErlaubt() &&
                _.get(angebotVm.angebotModel.angebot, 'aenderbareTarifmerkmale.fahrzeugtyp') !== false
            );
        }
        function isPostleitzahlFahrzeughalterErlaubt() {
            return AngebotKfzService.isPostleitzahlFahrzeughalterErlaubt(angebotVm.angebotModel.angebot);
        }
        function isFahrzeughalterErlaubt() {
            return erlaubteTarifmerkmale.fahrzeughalter;
        }
        function isFahrzeugZulassungAufFahrzeughalterErlaubt() {
            return erlaubteTarifmerkmale.zulassungAufFahrzeughalter;
        }
        function isSaisonkennzeichenErlaubt() {
            return AngebotKfzService.isSaisonkennzeichenErlaubt(angebotVm.angebotModel.angebot);

        }
        function isJaehrlicheFahrleistungErlaubt() {
            return AngebotKfzService.isJaehrlicheFahrleistungErlaubt(angebotVm.angebotModel.angebot);
        }
        function isMotorradHerstellerErlaubt() {
            return (
                _.includes([
                    wagniskennziffern.MOTORRAD
                ], wkzWert) &&
                _.get(angebotVm.ersatzgeschaeftAenderbarMap, 'angebotsgegenstandFahrzeug.motorradHersteller') !== false
            );
        }
        function isMotorleistungErlaubt() {
            return erlaubteTarifmerkmale.motorleistung;
        }
        function isNutzlastErlaubt() {
            return erlaubteTarifmerkmale.nutzlast;
        }
        function isFinanzierungErlaubt() {
            return erlaubteTarifmerkmale.finanzierung === true;
        }
        function isSitzplaetzeErlaubt() {
            return erlaubteTarifmerkmale.sitzplaetze;
        }
        function isNeuwertErlaubt() {
            return (
                    erlaubteTarifmerkmale.fahrzeugneuwert &&
                    ((
                        !angebotVm.fahrzeugNeuwertUeberSchwackeErmittelt &&
                        erlaubteTarifmerkmale.fahrzeugtyp &&
                        _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.hsnTsnBezeichnung') &&
                        _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.herstellerschluessel') &&
                        _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.typschluessel')
                    ) || (
                        !erlaubteTarifmerkmale.fahrzeugtyp
                    ))
            );
        }
        function isAufbauartErlaubt() {
            return erlaubteTarifmerkmale.aufbauart;
        }
        function isKaufpreisErlaubt() {
            return erlaubteTarifmerkmale.kaufpreis;
        }
        function isAntiblockiersystemErlaubt() {
            return erlaubteTarifmerkmale.abs;
        }
        function isGlasfaserkunststoffdachErlaubt() {
            return erlaubteTarifmerkmale.gfkDach;
        }
        function isQuadErlaubt() {
            return erlaubteTarifmerkmale.quad;
        }
        function getLinkBezeichnungFahrzeugsuche() {
            var suchTyp = _.get(angebotVm.angebotModel, 'formData.fahrzeugsuche.suchTyp');

            return suchTyp === 'detail' ? 'Komfortsuche' : 'Detailsuche';
        }
        function toggleFahrzeugsuche() {
            var suchTyp = _.get(angebotVm.angebotModel, 'formData.fahrzeugsuche.suchTyp');

            _.set(angebotVm.angebotModel, 'formData.fahrzeugsuche.suchTyp', suchTyp === 'komfort' ? 'detail' : 'komfort');
        }
        function resetFahrzeugsucheModelIfNeeded() {
            var herstellerschluessel = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.herstellerschluessel'),
                typschluessel = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.typschluessel'),
                fahrzeugsucheKomfortFahrzeug = _.get(angebotVm.angebotModel, 'formData.fahrzeugsuche.fahrzeug');

            if (MiscUtilsService.isEverythingEmpty(herstellerschluessel, typschluessel)) {
                return;
            }

            if (
                MiscUtilsService.isEmpty(fahrzeugsucheKomfortFahrzeug) ||
                fahrzeugsucheKomfortFahrzeug.hsn !== herstellerschluessel ||
                fahrzeugsucheKomfortFahrzeug.tsn !== typschluessel
            ) {
                _.set(angebotVm.angebotModel, 'formData.fahrzeugsuche.komfort.model', null);
                _.set(angebotVm.angebotModel, 'formData.fahrzeugsuche.detail.model', null);
                _.set(angebotVm.angebotModel, 'formData.fahrzeugsuche.fahrzeug', null);
            }
        }
        function onCloseFahrzeugsucheKomfort() {
            _.set(angebotVm.angebotModel, 'formData.fahrzeugsuche.typ', 'hsntsn');
        }
        function onChangeFahrzeugsuche(type, model) {
            _.set(angebotVm.angebotModel, 'formData.fahrzeugsuche.' + type +'.model', model);
        }
        function onSelectFahrzeugsuche(fahrzeug) {
            if (!isHsnTsnErlaubt() || MiscUtilsService.isAtLeastOneEmpty(fahrzeug, fahrzeug.hsn, fahrzeug.tsn)) {
                return;
            }

            _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.herstellerschluessel', fahrzeug.hsn);
            _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.typschluessel', fahrzeug.tsn);
            _.set(angebotVm.angebotModel, 'formData.fahrzeugsuche.typ', 'hsntsn');
            _.set(angebotVm.angebotModel, 'formData.fahrzeugsuche.fahrzeug', fahrzeug);

            $scope.$emit('iplusjs:tracking:triggerChangeEvent', [ _.get(vm.fzgForm, 'angebotsgegenstandFahrzeugHerstellerschluessel.$$element'), _.get(vm.fzgForm, 'angebotsgegenstandFahrzeugTypschluessel.$$element') ], {
                state: 'normal'
            });

            ermittleFahrzeugdatenUeberHsnTsn();

            var hsnElem = angular.element(_.get(vm.fzgForm, '$$element[0]'))[0].querySelector('[name="angebotsgegenstandFahrzeugHerstellerschluessel"]');

            if (hsnElem) {
                $timeout(function () {
                    hsnElem.focus();
                    HtmlUtilsService.scrollIntoViewIfNeeded(hsnElem, true);
                }, 0);
            }
        }
        function isDirectNavigationToStepErgebnisErlaubt() {
            return BasisAngebotService.isDirectNavigationToStepErgebnisErlaubt(angebotVm.angebotModel.angebot, vm.fzgForm);
        }
        function isFahrzeughalterPlzAbweichend(statusCodesToCheck) {
            var fahrzeughalterVnPlzAntragstellerPlzAbweichend = AngebotKfzService.isFahrzeughalterPlzAbweichend(angebotVm.angebotModel.angebot, 'ANGEBOT');

            if (fahrzeughalterVnPlzAntragstellerPlzAbweichend.status && (!statusCodesToCheck || _.includes(statusCodesToCheck, fahrzeughalterVnPlzAntragstellerPlzAbweichend.type))) {
                NavigationService.setFollowingDisabled(true);

                $scope.$emit('iplusjs:createAndAddAlert', {
                    message: AppConfig.MESSAGES.hinweisFahrzeughalterVnPlzAntragstellerPlzAbweichend[fahrzeughalterVnPlzAntragstellerPlzAbweichend.type],
                    type: 'alert',
                    id: 'hinweisFahrzeughalterVnPlzAntragstellerPlzAbweichend'
                });
            } else {
                $scope.$emit('iplusjs:removeAlert', {
                    id: 'hinweisFahrzeughalterVnPlzAntragstellerPlzAbweichend'
                });
            }

            return fahrzeughalterVnPlzAntragstellerPlzAbweichend;
        }
        function isNutzungsartErlaubt() {
            return erlaubteTarifmerkmale.nutzungsart;
        }
        function isGewerblicheBefoerderungErlaubt() {
            return (
                (
                    erlaubteTarifmerkmale.gewerblicheBefoerderung &&
                    !BasisAngebotService.isPrivatPerson(angebotVm.angebotModel.angebot) &&
                    isGevo('KFZ_TARIFUMSTELLUNG')
                ) || (
                    erlaubteTarifmerkmale.gewerblicheBefoerderung &&
                    BasisAngebotService.isPrivatPerson(angebotVm.angebotModel.angebot) &&
                    _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.nutzungsart.wert') === vm.CONSTANTS.nutzungsart.geschaeftlich.wert
                )
            );
        }
        function isHerstellerschluesselDisabled() {
            return (
                _.get(angebotVm.ersatzgeschaeftAenderbarMap, 'angebotsgegenstandFahrzeug.herstellerschluessel') === false ||
                _.get(angebotVm.angebotModel.angebot, 'aenderbareTarifmerkmale.fahrzeugtyp') === false
            );
        }
        function isTypschluesselDisabled() {
            return (
                _.get(angebotVm.ersatzgeschaeftAenderbarMap, 'angebotsgegenstandFahrzeug.typschluessel') === false ||
                _.get(angebotVm.angebotModel.angebot, 'aenderbareTarifmerkmale.fahrzeugtyp') === false
            );
        }
        function isFahrzeughaltereigenschaftDisabled() {
            return (
                _.get(angebotVm.ersatzgeschaeftAenderbarMap, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft') === false ||
                _.get(angebotVm.angebotModel.angebot, 'aenderbareTarifmerkmale.rolleFahrzeughalter') === false
            );
        }
        function isMotorleistungDisabled() {
            return (
                _.get(angebotVm.ersatzgeschaeftAenderbarMap, 'angebotsgegenstandFahrzeug.motorleistung') === false ||
                _.get(angebotVm.angebotModel.angebot, 'aenderbareTarifmerkmale.motorleistung') === false
            );
        }
        function isSaisonkennzeichenDisabled() {
            return (
                _.get(angebotVm.ersatzgeschaeftAenderbarMap, 'angebotsgegenstandFahrzeug.saisonfahrzeug') === false ||
                _.get(angebotVm.angebotModel.angebot, 'aenderbareTarifmerkmale.saisonfahrzeug') === false
            );
        }
        function isSaisonzeitraumVonDisabled() {
            return (
                _.get(angebotVm.ersatzgeschaeftAenderbarMap, 'angebotsgegenstandFahrzeug.saisonzeitraumVon') === false ||
                _.get(angebotVm.angebotModel.angebot, 'aenderbareTarifmerkmale.saisonfahrzeug') === false
            );
        }
        function isSaisonzeitraumBisDisabled() {
            return (
                _.get(angebotVm.ersatzgeschaeftAenderbarMap, 'angebotsgegenstandFahrzeug.saisonzeitraumBis') === false ||
                _.get(angebotVm.angebotModel.angebot, 'aenderbareTarifmerkmale.saisonfahrzeug') === false
            );
        }
        function isFahrzeugZulassungAufFahrzeughalterDisabled() {
            return (
                (
                    _.get(angebotVm.ersatzgeschaeftAenderbarMap, 'angebotsgegenstandFahrzeug.zulassungAufFahrzeughalter') === false ||
                    _.get(angebotVm.angebotModel.angebot, 'aenderbareTarifmerkmale.zulassungAufFahrzeughalter') === false
                )
            );
        }
        function isAufbauartDisabled() {
            return (
                _.get(angebotVm.ersatzgeschaeftAenderbarMap, 'angebotsgegenstandFahrzeug.aufbauart') === false ||
                _.get(angebotVm.angebotModel.angebot, 'aenderbareTarifmerkmale.aufbauart') === false
            );
        }

        function isFahrzeugErstzulassungDisabled() {
            return (
                _.get(angebotVm.ersatzgeschaeftAenderbarMap, 'angebotsgegenstandFahrzeug.erstzulassung') === false
            );
        }

        function saisonzeitraumBisOrder(value) {
            var saisonzeitraumVon = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonzeitraumVon');

            if (saisonzeitraumVon) {
                if (_.indexOf(angebotVm.CONSTANTS.monate, value) + 1 > saisonzeitraumVon) {
                    return 0;
                } else {
                    return 1;
                }
            } else {
                return 1;
            }
        }
        function isGevo(gevo) {
            return AngebotKfzService.isGevo(angebotVm.angebotModel.angebot, gevo);
        }

        function getMotorleistungTyp() {
            vm.motorleistungTyp = _.get(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungTyp') || 'kW';
        }

        function isHinweisFahrzeugErstzulassungSichtbar() {
            var erstzulassung = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.erstzulassung'),
                fahrzeugDatenHsnTsn = _.get(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.fahrzeugDatenHsnTsn'),
                herstellerschluessel = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.herstellerschluessel'),
                typschluessel = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.typschluessel');

            if (MiscUtilsService.isAtLeastOneEmpty(erstzulassung, herstellerschluessel, typschluessel, fahrzeugDatenHsnTsn)) {
                return false;
            }

            return (
                fahrzeugDatenHsnTsn.produktionsbeginn &&
                fahrzeugDatenHsnTsn.produktionsende &&
                (
                    moment(erstzulassung, AppConfig.API.dateFormat).isBefore(moment(fahrzeugDatenHsnTsn.produktionsbeginn, 'YYYY').startOf('year')) ||
                    moment(erstzulassung, AppConfig.API.dateFormat).isAfter(moment(fahrzeugDatenHsnTsn.produktionsende, 'YYYY').endOf('year'))
                )
            );
        }

        function onMotorleistungChanged() {
            _.set(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.motorleistung', _.get(angebotVm.angebotModel.formData, 'angebotsgegenstandFahrzeug.motorleistungInKw'));
        }
    }
})();
